import { render, staticRenderFns } from "./TicketsStatusesSearch.vue?vue&type=template&id=4fb253d2&scoped=true&"
import script from "./TicketsStatusesSearch.vue?vue&type=script&lang=js&"
export * from "./TicketsStatusesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb253d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
